import PostsHomePage from "../components/PostsHomePage.vue";
import PostDetailPage from "../components/PostDetailPage.vue";
export default {
  children: [
    {
      path: "",
      name: "posts-home",
      component: PostsHomePage,
       meta: { countViews: true }
    },
    {
      path: ":id",
      name: "post-detail",
      component: PostDetailPage,
      props: true,
       meta: { countViews: true }
    },
  ],
};